
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./MainApp": () => {
return Promise.all(/*  | __federation_expose_MainApp */ [__webpack_require__.e(489), __webpack_require__.e(936), __webpack_require__.e(295), __webpack_require__.e(318), __webpack_require__.e(153), __webpack_require__.e(452), __webpack_require__.e(354), __webpack_require__.e(669)]).then(() => (() => (__webpack_require__(69807))));
},
"./shellSurfaceNavTargets": () => {
return Promise.all(/*  | __federation_expose_shellSurfaceNavTargets */ [__webpack_require__.e(489), __webpack_require__.e(936), __webpack_require__.e(153), __webpack_require__.e(452), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(21133))));
},
"./ShellModule": () => {
return __webpack_require__.e(/*  | __federation_expose_ShellModule */ 303).then(() => (() => (__webpack_require__(55990))));
},
"./ShellModuleViewProps": () => {
return __webpack_require__.e(/*  | __federation_expose_ShellModuleViewProps */ 418).then(() => (() => (__webpack_require__(65121))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };